var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.283 3.532a.4.4 0 0 0-.566-.565L12.92 4.763a4.9 4.9 0 0 0-6.907 6.907l-1.796 1.797a.4.4 0 0 0 .566.566l.578-.579a6.62 6.62 0 0 0 3.889 1.44v.95H8.8a.4.4 0 1 0 0 .8h1.7a.4.4 0 0 0 0-.8h-.45v-.967A6.65 6.65 0 0 0 14.705 4.11l.578-.578ZM14.135 4.68l-.649.649a4.9 4.9 0 0 1-6.907 6.907l-.648.648a5.85 5.85 0 0 0 8.205-8.205ZM9.75 4.4a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2Z",
    fill: "#282830"
  })));
};
export default SvgWebsite;